const DEV_REGEX = /(local\.bloomberg\.com)|(localhost)/;
const DEV_PAGE = /abba-client/;
const DEV_IMPERSONATOR_PORT = /4321/;
const STAGING_REGEX = /(origin\.(?!(www)).*|.*staging.*|.*-stg.*|.*stg-.*|.*\.cm.*)\.bloomberg\.(com|co\.[a-zA-Z]{2})/;
const BLUE_REGEX = /.*blue\.bloomberg\.com/;
const BAZAAR_REGEX = /bazaar-production\.cm\.bloomberg\.com/;

function useLocalData() {
    const host = window?.location?.host;
    const pathname = window?.location?.pathname;
    const port = window?.location?.port;

    // useLocalData is true if we want abba-client to get the feed from a local abba
    // via the old api that will then read the feed from a local file rather than
    // from the standard s3 locations which staging and prod use
    // support both the abba dashboard abba-client test page and the impersonator test page
    return (DEV_REGEX.test(host) && DEV_PAGE.test(pathname)) || (DEV_REGEX.test(host) && DEV_IMPERSONATOR_PORT.test(port));
}

function useStagingData() {
    const host = window?.location?.host;

    // blue and bazaar-production is treated as a production like env
    return (DEV_REGEX.test(host) || STAGING_REGEX.test(host)) && !BLUE_REGEX.test(host) && !BAZAAR_REGEX.test(host);
}

export const URLS = {
    // File containing sell through rates
    STR_FILE_URL: "https://assets.bwbx.io/s3/mediaservices/superelastic/data.json",
    // Coordinator service URL for project fortress
    COORDINATOR_SERVICE_URL: useStagingData() ? "https://coordinator-stg.cm.bloomberg.com/coordination" : "https://coordinator.cm.bloomberg.com/coordination",
    // Abba Feeds JSON by platform base URL
    ABBA_FEED_S3_URL_BASE: useLocalData()
        ? "http://local.bloomberg.com:3400/feed"
        : (useStagingData() ? "https://assets-dev.bwbx.io/s3/abba/feed" : "https://assets.bwbx.io/s3/abba/feed"),
};
